import { ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from '../../../../services/user.service';
import { CustomValidators } from 'ng2-validation';
import { CommonService } from '../../../../services/common.service';
import { environment } from 'src/environments/environment';
import { maxYearFunction } from '../../../../_helpers/utility';
import { MustMatch } from '../../../../_helpers/must-match.validator';
//import * as moment from 'moment';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import * as moment from 'moment-timezone';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { FileUpload } from 'primeng/fileupload';

@Component({
    selector: 'app-profile-edit',
    templateUrl: './profile-edit.component.html',
    styleUrls: ['./profile-edit.component.scss'],
    providers: [ConfirmationService, MessageService]
})
export class ProfileEdit2Component implements OnInit {
    activeIndex: number = -1;

    showOtpmodal: boolean = false;
    id;
    userForm: FormGroup;
    passwordform: FormGroup;
    deleteAccountForm: FormGroup;
    submittedPassword = false;

    emailadamin;
    submitted = false;
    uploadedFiles: any[] = [];
    file: File;
    reader: FileReader;
    public profilepic;
    errorMessage = '';
    public item: any[] = [];
    countrylist: any = [];
    statelist: any = [];
    citylist: any = [];
    genders: any = [];
    public imageProfile;
    public phoneNumber;
    showProfile = false;
    statuses: any = [];
    userstatus: any;
    usergender: any;
    selectedStatus: any;
    countryname;
    countrycode;
    statename;
    statecode;
    cityname;
    citycode;
    dob: Date;
    bDate;
    showProfileUpdateMesage;
    dobdt: Date;
    yearRange;
    public defaultDate: Date = new Date(environment.defaultDate);
    minYear = environment.minYear;
    minYearRange = new Date(environment.minYear);
    timeZoneArray = [];
    timeZoneOffset;
    timeZone;
    cpassword: boolean;
    newPasswordCheck: boolean;
    newPasswordDisable: boolean;
    public otp: string;
    public config = {
        allowNumbersOnly: true,
        length: 6,
        isPasswordInput: false,
        disableAutoFocus: false,
        required: true,
        placeholder: '',
        inputStyles: {
            'width': '50px',
            'height': '50px'
        }
    };
    public loggedInUser;
    public isLoggedIn: boolean;
    public userId;
    public profileDetails;
    public showGenderRequired: boolean = false;
    public showOtpErrors: boolean = false;
    public showOtpErrorsMsg: boolean = false;
    public showResendButton: boolean = false;
    public otpErrorMessage;
    public displayTime;
    public isVerified: boolean = false;
    public reasonList: any = [];
    public submittedDeleteAccount: boolean = true;
    public showMessageInput: boolean = false;
    selectedReason: any;
    public videoForm: FormGroup;
    public videoUploadedFiles: any[] = [];
    public userVideo;
    public showVideoError: boolean = false;
    public selectedPlayerVideo;
    public isVideoApproved: boolean = false;
    public contactVideoApproved: boolean = false;
    rejectedVideoListPresent: boolean = false;
    rejectedVideoList: any;
    isProfileComplete: boolean = false;
    tooltipContent: string;
    public userCategories = environment.userCategories;
    rolearray: any;
    userCategory;
    selectedRoleid;
    maxYear: any;
    daysTogo: any;
    minDateValue: Date;
    page: any;
    maxDate: Date;
    isContestVerified: boolean;
    isAbove18: boolean = false;
    @ViewChild('fileUpload') fileUpload!: FileUpload;
    imageChangedEvent: any = '';
    croppedImage: any = '';
    cropDialog: boolean = false;
    selectedFile: File | null = null;
    existimageShow: boolean = true;
    imageSize = 1000000;
    croppedImageMaxSize = 1000000;
    croppedImageSize = 0;
    croppedImageError: string | null = null;
    scale = 1;
    transform: ImageTransform = {};
    constructor(private userService: UserService, private commonService: CommonService, private formBuilder: FormBuilder,
        private renderer: Renderer2,
        private confirmationService: ConfirmationService, private messageService: MessageService, private changeDetector: ChangeDetectorRef,
        private router: Router, private activeroute: ActivatedRoute, private authService: AuthService, private tokenStorage: TokenStorageService, private userservice: UserService) { }

    ngOnInit(): void {
        const date = new Date();
        const [currentDate, currentMonth] = [date.getDate(), environment.months[date.getMonth()].label];
        this.maxDate = new Date(currentDate + ' ' + currentMonth + ' 2019');
        this.activeroute.queryParams.subscribe((res) => {
            this.page = res['page'];
            this.isAbove18 = res['isAbout18'] ?? false;
        })
        this.renderer.addClass(document.body, 'profile_body');
        this.loggedInUser = this.tokenStorage.getUser();
        this.rolearray = this.tokenStorage.getRolelist();
        if (this.loggedInUser.userdata != undefined) {
            this.isLoggedIn = true;
            this.userId = this.loggedInUser.userdata.id;
            this.isContestVerified = this.loggedInUser.userdata.isContestVerified;
        }        
        if (this.isLoggedIn == false) {
            this.router.navigate(['/']);
        }
        const timeZones = moment.tz.names();
        for (const timezone of timeZones) {
            this.timeZoneArray.push({ name: timezone, code: moment().tz(timezone).format('Z') });
        }
        this.defaultDate.setDate(this.defaultDate.getDate() - 5);
        this.minDateValue = new Date();
        this.yearRange = this.minYear + ":" + maxYearFunction();
        // this.yearRange = this.minYear + ":" + this.minDateValue.getFullYear();
        this.maxYear = moment().subtract(5, 'years').toDate();
        //this.id = this.activeroute.snapshot.params.id;
        this.id = this.userId;
        this.statuses = [
            { label: 'Active', value: true },
            { label: 'In-Active', value: false }
        ];
        this.genders = [
            { name: 'Male', code: 'Male' },
            { name: 'Female', code: 'Female' },
            { name: 'Other', code: 'Other' },
        ];
        this.getCountry();
        this.userForm = this.formBuilder.group({
            //   firstName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')] ],
            //   lastName: ['', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z]*$')]],
            firstName: ['', {
                validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')], updateOn: 'blur'
            }],
            lastName: ['', {
                validators: [Validators.required, Validators.pattern('[A-Za-z][A-Za-z]*$')], updateOn: 'blur'
            }],
            email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z]+(\.[a-z0-9]+)?@[a-z0-9]+\.(com|in|org|net|edu|gov|mil|co\.[a-z]{2})$')]],
            // password: ['', [Validators.required, Validators.minLength(6)]],
            // confirmPassword: ['', Validators.required],
            mobileNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
            address: [''],
            country: ['', Validators.required],
            state: ['', Validators.required],
            city: ['', Validators.required],
            zipcode: ['', Validators.required],
            status: [''],
            gender: ['', {
                validators: [Validators.required]
            }],
            dob: ['', {
                validators: [Validators.required]
            }]
        });
        this.userCategories.forEach(element => {
            this.userForm.addControl(element.slug, new FormControl());
        })
        this.passwordform = this.formBuilder.group({
            currentPassword: ['', [Validators.required]],
            password: ['', {
                validators: [Validators.required, Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")], updateOn: 'blur'
            }],
            confirmPassword: ['', Validators.required],
        }, {
            validator: MustMatch('password', 'confirmPassword')
        });
        this.reasonList = [
            { id: 1, label: 'Not happy with us.' },
            { id: 2, label: 'Get another application.' },
            { id: 3, label: 'Not easy to use.' },
            { id: 4, label: 'Other' },
        ];
        this.deleteAccountForm = this.formBuilder.group({
            reason: ['', [Validators.required]],
            message: [''],
        });

        this.videoForm = this.formBuilder.group({
            //youtubevideourl: ['', Validators.required],

        });
    }
    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'profile_body');
    }
    get deleteReqForm() {
        return this.deleteAccountForm.controls;
    }
    // newPassword(event) {
    //     if (this.passwordform.controls['password'].value != '' && this.passwordform.controls['currentPassword'].value == '') {
    //         this.passwordform.controls['currentPassword'].setValidators([Validators.required]);
    //         this.cpassword = true;
    //         this.newPasswordCheck = false;
    //     } else {
    //         this.cpassword = false;
    //     }
    // }
    // newPasswordValidation(event) {
    //     this.passwordform.get('password').enable()
    //     this.passwordform.get('confirmPassword').enable()
    //     if (this.passwordform.controls['currentPassword'].value != '' && this.userForm.controls['password'].value == '') {
    //         this.passwordform.controls['password'].setValidators([Validators.pattern("^(?=[^A-Z\n]*[A-Z])(?=[^a-z\n]*[a-z])(?=[^0-9\n]*[0-9])(?=[^#?!@$%^&*\n-]*[#?!@$%^&*-]).{6,}$")]);
    //         this.newPasswordCheck = true;
    //         this.cpassword = false;
    //     } else {
    //         this.newPasswordCheck = false;
    //     }
    // }

    onFileSelect(event: any) {
        const file = event.files[0];
        if (!file) return;
        if (file.size > this.imageSize) {
            this.rejectOversizedImage();
            return;
        }
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = file;
        const fileEvent: any = {
            target: {
                files: [file]
            }
        };
        this.imageChangedEvent = fileEvent;
        this.cropDialog = true;
    }

    imageCropped(event: ImageCroppedEvent) {
        this.croppedImage = event.base64;
        this.croppedImageSize = this.getBase64SizeBytes(this.croppedImage);
        this.croppedImageError = this.croppedImageSize > this.croppedImageMaxSize
            ? 'Cropped image size must be less than 1 MB.'
            : null;
    }

    getBase64SizeBytes(base64: string): number {
        if (!base64) return 0;
        return Math.round(
            (base64.length * (3 / 4)) -
            (base64.split(',')[0].length + 1)
        );
    }

    applyCrop() {
        if (this.croppedImageError) return;
        const file = this.base64ToFile(
            this.croppedImage,
            this.selectedFile?.name || 'image.png'
        );
        if (file.size > this.croppedImageMaxSize) {
            this.croppedImageError = 'Cropped image size must be less than 1 MB.';
            return;
        }
        this.fileUpload.clear();
        const event = {
            files: [file]
        };
        this.picUploader(event);
        this.fileUpload.files = [file];
        this.cropDialog = false;
        this.existimageShow = false;
    }

    onCropCancel() {
        this.cropDialog = false;
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;
        if (this.fileUpload) {
            this.fileUpload.clear();
        }
        this.uploadedFiles = [];
        this.profilepic = null;
    }

    rejectOversizedImage() {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'File Too Large', detail: 'Please upload an image smaller than 1 MB', life: 6000 });
        this.onCropCancel();
    }

    base64ToFile(data: string, filename: string): File {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    picUploader(event) {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
            var reader = new FileReader();
            reader.readAsDataURL(this.uploadedFiles[0]);
            reader.onload = () => { // called once readAsDataURL is completed
                this.profilepic = reader.result;
            }
        }
    }
    public countryName;
    public countryCode;
    getCountry() {
        this.commonService.getCountryList().subscribe(
            data => {
                this.getUserDetails(this.id);
                this.changeDetector.detectChanges();
                this.countrylist = data.data.items;
                this.countryName = "India";
                this.countryCode = "IN";
                setTimeout(() => {
                    this.userForm.controls.country.setValue({ name: this.countryName, code: this.countryCode });
                }, 1000);
                this.getStates("false", this.countryCode);
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }

    getStates(fromForm, event) {
        this.citylist = [];


        if (fromForm == "true") {
            this.userForm.get('state').reset();
            this.userForm.get('city').reset();
            this.userForm.get('zipcode').reset();
            this.countrycode = event.value.code;
            this.countryname = event.value.name;
            this.statecode = "";
            this.statename = "";
            this.citycode = "";
            this.cityname = "";
        } else {
            this.countrycode = "IN";
        }

        this.commonService.getStateList(this.countrycode).subscribe(
            data => {
                this.statelist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    onGenderSelect(event) {
        if (event) {
            this.usergender = event.name;
        }
    }

    getCities(fromForm, event) {

        if (fromForm == "true") {
            this.userForm.get('zipcode').reset();
            this.statecode = event.value.code;
            this.statename = event.value.name;
            this.userForm.controls.city.setValue('');
        } else {
            this.statecode = event;
        }


        this.commonService.getCityList(this.statecode).subscribe(
            data => {
                this.citylist = data.data.items;
            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    onOtpChange(otp) {
        this.otp = otp;
    }
    getUserDetails(id) {
        this.userService.getUserDetails(id).subscribe(
            data => {
                this.item = data;
                if (data.isMobileVerified == true) {
                    this.isVerified = true
                }
                if (this.item) {
                    this.daysTogo = this.item['daysTogo'];
                    this.getStates("false", this.item['countrycode']);
                    this.userForm.get('country').setValue({ name: this.item['countryname'], code: this.item['countrycode'] });
                    if (this.item['statecode']) {
                        this.getCities("false", this.item['statecode']);
                        this.userForm.get('state').setValue({ name: this.item['statename'], code: this.item['statecode'] });
                    }
                    if (this.item['citycode']) {
                        this.userForm.get('city').setValue({ name: this.item['cityname'], code: this.item['citycode'] });
                    }
                    if (this.item['gender']) {
                        this.userForm.get('gender').setValue({ name: this.item['gender'], code: this.item['gender'] });
                    }
                    //   var bDate = moment(this.item['dob'], 'DD-MM-YYYY');
                    this.isProfileComplete = this.item['isProfileComplete']
                    if (this.isProfileComplete == false) {
                        this.tooltipContent = "Please complete your profile to upload video"
                    }
                    //   this.bDate = bDate.format('DD-MM-YYYY');
                    const dobDate = this.item['dob'].split('-');
                    this.userForm.patchValue({
                        firstName: this.item['firstName'],
                        lastName: this.item['lastName'],
                        email: this.item['email'],
                        mobileNumber: this.item['mobileNumber'],
                        // country: this.item['country'],
                        // state: this.item['state'],
                        // city: this.item['city'],
                        zipcode: this.item['zipcode'],
                        address: this.item['address'],
                        dob: new Date(dobDate[2] + '-' + dobDate[1] + '-' + dobDate[0]),
                    });
                    this.phoneNumber = this.item['mobileNumber']
                    this.countrycode = this.item['countrycode'];
                    this.countryname = this.item['countryname'];
                    this.statecode = this.item['statecode'];
                    this.statename = this.item['statename'];
                    this.citycode = this.item['citycode'];
                    this.cityname = this.item['cityname'];
                    this.selectedPlayerVideo = this.item['playervideoClip'];

                    if (!this.item['isplayerVideoApproved'] && this.selectedPlayerVideo != "") {
                        this.isVideoApproved = true;
                    } else {
                        this.isVideoApproved = false;
                    }

                    if (this.item['isplayerVideoApproved'] && this.selectedPlayerVideo != "") {
                        this.contactVideoApproved = true;
                    } else {
                        this.contactVideoApproved = false;
                    }
                    // console.log(this.statecode);
                    // console.log(this.statename);
                    // console.log(this.citycode);
                    // console.log(this.cityname);
                    var statusobj;
                    //   if (this.item['status'] == true) {
                    //       statusobj = { label: 'Active', value: true };
                    //   } else {
                    //       statusobj = { label: 'In-Active', value: false };
                    //   }
                    //   this.userForm.get('status').setValue(statusobj);

                    if (this.item['profilepic'] != undefined) {
                        this.imageProfile = this.item['profilepic'];
                        this.showProfile = true;
                    } else {
                        this.showProfile = false;
                    }
                }
                this.emailadamin = this.item['count'] >= 2 ? 'support@tplsport.com.' : null;
                this.showProfileUpdateMesage = this.item['count'] >= 2 ? 'If you are unable to update your address, email admin at' : null

                if (this.item['count'] >= 2) {
                    this.userForm.get('country').disable();
                    this.userForm.get('state').disable();
                    this.userForm.get('city').disable();
                    this.userForm.get('zipcode').disable();
                    this.userForm.get('address').disable();
                }
                if (this.item['email'] === null) {
                    this.userForm.get('email').enable();
                } else {
                    this.userForm.get('email').disable();
                }
                // this.userForm.get('password').disable()
                // this.userForm.get('confirmPassword').disable()
                if (this.item["rejectedReasons"]) {
                    if (this.item["rejectedReasons"].length > 0) {
                        this.rejectedVideoListPresent = true
                        this.rejectedVideoList = this.item["rejectedReasons"]

                    }

                }
                if (this.item['rolename']) {

                    this.userCategories.forEach(element => {
                        let obj = { name: element.name, value: element.value, status: false, slug: element.slug };
                        if (element.slug == this.item['rolename']) {
                            const index = this.findIndexBySlug(element.value, this.userCategories);
                            obj = { name: element.name, value: element.value, slug: element.slug, status: true };
                            this.userCategories[index] = obj;
                            this.userForm.get(element.slug).setValue(obj);
                        }
                    })
                }

            },
            err => {
                this.errorMessage = err.error.message;
            }
        );
    }
    findIndexBySlug(slug, arrayName) {
        let index = -1;
        for (let i = 0; i < arrayName.length; i++) {
            if (arrayName[i].slug === slug) {
                index = i;
                break;
            }
        }
        return index;
    }
    onCategorySelect(userCategory, event) {

        this.userCategory = '';
        if (event.isTrusted) {
            this.userCategory = userCategory.value;

            this.userCategories.forEach(element => {
                let obj = { name: element.name, value: element.value, status: element.status, slug: element.slug };
                if (this.userCategory == element.value) {
                    const index = this.findIndexByValue(element.value, this.userCategories);
                    obj = { name: element.name, value: element.value, status: true, slug: element.slug };
                    this.userCategories[index] = obj;
                    this.userForm.get(element.slug).setValue(obj);
                    const roleindex = this.findIndexByRole(element.slug, this.rolearray);
                    this.selectedRoleid = this.rolearray[roleindex]['roleid'];
                } else {
                    const index = this.findIndexByValue(element.value, this.userCategories);
                    obj = { name: element.name, value: element.value, status: false, slug: element.slug };
                    this.userCategories[index] = obj;
                }
            });
        }
    }
    findIndexByValue(value, arrayName) {
        let index = -1;
        for (let i = 0; i < arrayName.length; i++) {
            if (arrayName[i].value === value) {
                index = i;
                break;
            }
        }
        return index;
    }
    findIndexByRole(value, arrayName) {
        let index = -1;
        for (let i = 0; i < arrayName.length; i++) {
            if (arrayName[i].rolename === value) {
                index = i;
                break;
            }
        }
        return index;
    }

    get f() {
        return this.userForm.controls;
    }
    backLink() {
        this.router.navigate(['/profile-info']);
    }
    showotpModal() {
        this.showOtpmodal = true;
        this.resendOtp();
    }
    removeFile(event) {
        this.uploadedFiles = [];
        this.profilepic = "{{imageProfile}}";
    }

    onCitySelect(event) {
        this.cityname = event.value.name;
        this.citycode = event.value.code;
        this.userForm.get('zipcode').reset();
    }
    onSubmit() {
        this.submitted = true;
        if (this.userForm.invalid) {
            return;
        }
        // if(this.usergender==null){
        //     this.showGenderRequired=true;
        //     return;
        // }
        // console.log(this.statecode);
        // console.log(this.statename);
        // console.log(this.citycode);
        // console.log(this.cityname);
        var userData = this.userForm.value;
        userData['profilepic'] = this.profilepic;
        userData['status'] = this.userstatus;
        userData['countrycode'] = this.countrycode;
        userData['countryname'] = this.countryname;
        userData['statecode'] = this.statecode;
        userData['statename'] = this.statename;
        userData['citycode'] = this.citycode;
        userData['cityname'] = this.cityname;
        userData['gender'] = this.usergender;
        userData['isContestVerified'] = true;
        //unCommented below line 657 to bypass DOB verification on 23 oct 26  once 3rd party check integrated comment it again
        userData['isProfileComplete'] = true;
        userData['rolename'] = this.userCategory;
        userData['roleid'] = this.selectedRoleid;
        if (this.item['email'] !== null) {
            delete userData['email'];
        }
        // console.log(userData);
        // return;
        if (this.userForm.value.dob instanceof Date) {
            userData['dob'] = moment(this.userForm.value.dob, "DD-MM-YYYY").format("YYYY-MM-DD");
        } else {
            var dt = moment(this.userForm.value.dob, "DD-MM-YYYY").format("YYYY-MM-DD");
            userData['dob'] = dt;
        }
        userData = JSON.stringify(userData, null, 4);
        this.userService.updateUser(this.id, userData).subscribe(
            data => {
                let userData = this.loggedInUser;
                this.tokenStorage.removeUser();
                userData.userdata.isProfileComplete = data.data.isProfileComplete;
                userData.userdata.isContestVerified = data.data.isContestVerified;
                userData.userdata.showWelcomeLogin = false;
                this.tokenStorage.saveUser(userData);
                // return;
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'My Profile completed successfully!', life: 6000 });
                
                //Commented below code to bypass DOB verification on 23 oct 26  once 3rd party check integrated remove code from line number 684 to 692
                /*if (this.page === 'home' || (this.page === 'contest' && this.isAbove18 === false)) {
                    setTimeout(() => {
                        this.router.navigate(['/' + this.page]);
                    }, 2000);
                } else {
                    setTimeout(() => {
                        this.router.navigate(['/dob-verification'], { queryParams: { isAbout18: data.data.isAbove18, page: this.page } });
                    }, 2000);
                }                
                */
                if (this.page === 'home' || this.page === 'contest' || this.page === 'tournaments') {
                    setTimeout(() => {
                        this.router.navigate(['/' + this.page]);
                    }, 2000);
                } else {
                    setTimeout(() => {
                        this.router.navigate(['/']);
                    }, 2000);
                }
            },
            err => {
                //   this.errorMessage = err.error.message;
            }
        );
    }

    onReasonSelect(event) {
        if (event.value.id === 4) {
            this.showMessageInput = true;
        } else {
            this.showMessageInput = false;
        }
        this.selectedReason = event.value.label;
    }
    submitDeleteAccount() {
        this.submittedDeleteAccount = true;
        if (this.deleteAccountForm.invalid) {
            return;
        }
        var deleteAccountReqData = this.deleteAccountForm.value;
        deleteAccountReqData['reason'] = this.selectedReason;
        deleteAccountReqData = JSON.stringify(deleteAccountReqData, null, 4);
        this.userService.deleteAccountRequest(deleteAccountReqData).subscribe(
            data => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Delete Account Request send to admin Successfully!. Account will be delete within 48 hrs', life: 6000 });
            },
            err => {
                //   this.errorMessage = err.error.message;
            }
        );
    }
    timer(minute) {
        // let minute = 1;
        let seconds: number = minute * 60;
        let textSec: any = "0";
        let statSec: number = 60;

        const prefix = minute < 10 ? "0" : "";

        const timer = setInterval(() => {
            seconds--;
            if (statSec != 0) statSec--;
            else statSec = 59;

            if (statSec < 10) {
                textSec = "0" + statSec;
            } else textSec = statSec;
            if (this.showOtpmodal == true) {
                this.displayTime = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
            } else {
                clearInterval(timer);
            }
            if (seconds == 0) {
                clearInterval(timer);
                this.showResendButton = true;
            }
        }, 1000);
    }
    onMobilePhoneSubmit(mode) {

        console.log("mobileotp")

        if (mode != "resend") {
            this.submitted = true;

        }
        this.authService.generateMobileOtp(this.phoneNumber).subscribe(
            res => {
                this.showResendButton = false;
                this.timer(5);
            }, err => {
                console.log(err)
            });
    }
    resendOtp() {
        let mode = 'resend';
        this.onMobilePhoneSubmit(mode);
    }
    onClickOtpSubmit() {
        if (this.otp == undefined || this.otp.length < 6) {
            this.showOtpErrors = true;
            // setTimeout(() => {
            //   this.showOtpErrors = false;
            // }, 5000);
            return;
        }
        let otpData = {
            'otp': this.otp,
            'mobileNumber': this.phoneNumber,
        }
        console.log(this.otp)
        this.authService.verifyOtp(otpData).subscribe(
            data => {


                this.router.navigate(['/profile-info']);
            },
            ((err) => {
                this.showOtpErrorsMsg = true;
                this.otpErrorMessage = err.error.error;


            })
        );
    }

    onReset() {
        this.submitted = false;
        this.userForm.reset();
    }


    //=========security-form-control=================\\

    get h() {
        return this.passwordform.controls;
    }

    changepassword() {
        this.submittedPassword = true;
        if (this.passwordform.invalid) {
            return;
        }
        var passworddata = this.passwordform.value;
        passworddata = JSON.stringify(passworddata, null, 4);
        this.updatepassword(passworddata);
    }
    updatepassword(passworddata) {
        this.userservice.updateUser(this.id, passworddata).subscribe(
            () => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Password Updated Successfully', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/profile-info']);
                }, 2000);
                this.uploadedFiles = [];
            },
            ((err) => {
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Password Update failed', life: 6000 });
            })
        );
    }

    videoUploader(event) {
        let index = 0;
        for (let file of event.files) {
            this.videoUploadedFiles.push(file);
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                // called once readAsDataURL is completed
                if (reader.result != null) {
                    //this.sponsorImage.push({ 'file': reader.result });
                    this.userVideo = reader.result;
                    index++;
                }
            }
        }
    }
    removeVideoFile(event) {
        this.videoUploadedFiles = [];
        //this.profilepic = "{{imageProfile}}";
    }
    onSubmitvideo() {
        ///this.submitted = true;
        if (this.videoUploadedFiles.length <= 0) {
            this.showVideoError = true;
            return;
        } else {
            this.showVideoError = false;
        }

        let videoData = this.videoForm.value;
        videoData['playervideo'] = this.userVideo;
        //console.log(videoData);

        //videoData['teamId'] = this.teamId;
        // if (this.isVideoAdd) {
        //   videoData = JSON.stringify(videoData, null, 4);
        //   this.addTeamVideo(videoData);
        // } else {
        //   videoData = JSON.stringify(videoData, null, 4);
        //   this.updateVideo(this.teamVideoId, videoData);
        // }
        videoData = JSON.stringify(videoData, null, 4);
        this.userservice.updateUser(this.id, videoData).subscribe(
            () => {
                this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Player Video Clip Uploaded Successfully', life: 6000 });
                setTimeout(() => {
                    this.router.navigate(['/profile-info']);
                }, 2000);
                this.uploadedFiles = [];
                this.videoForm.reset();
                this.videoUploadedFiles = [];
            },
            ((err) => {
                this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Password Update failed', life: 6000 });
            })
        );
    }
    addTeamVideo(videoData) {
        // this.teamVideoService.addTeamVideo(videoData).subscribe(
        //   data => {
        //     this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Team video added successfully.', life: 6000 });
        //     setTimeout(() => {
        //       this.router.navigate(['/manage/teamdetails/addmedia'], { queryParams: { teamId: this.teamId } });
        //     }, 2000);
        //     this.showvideo = false;
        //     this.videoForm.reset();
        //     this.teamVideo = '';
        //     this.videoUploadedFiles = [];
        //     this.getTeamVideos();
        //   },
        //   err => {
        //     this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.message, life: 6000 });
        //   }
        // );
    }
    updateVideo(teamVideoId, videoData) {
        // this.teamVideoService.updateTeamVideo(teamVideoId, videoData).subscribe(
        //   data => {
        //     this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Team video updated successfully.', life: 6000 });
        //     setTimeout(() => {
        //       this.router.navigate(['/manage/teamdetails/addmedia'], { queryParams: { teamId: this.teamId } });
        //     }, 2000);
        //     this.showvideo = false;
        //     this.videoForm.reset();
        //     this.teamVideo = '';
        //     this.videoUploadedFiles = [];
        //     this.getTeamVideos();
        //   },
        //   err => {
        //     this.messageService.add({ key: 'toastmsg', severity: 'error', summary: 'Error', detail: err.error.message, life: 6000 });
        //   }
        // )
    }
    toggleAccordion() {
        this.activeIndex = this.activeIndex === 0 ? -1 : 0;
    }

    get cropDialogTitle(): string {
        return 'Crop & Adjust Profile Image';
    }

    get cropDialogSubtitle(): string {
        return 'Position and scale image to fit mandatory 512 x 512 dimensions';
    }

    get cropPreviewLabel(): string {
        return '512 x 512 px';
    }
    zoomIn() {
        this.scale += 0.1;

        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }

    zoomOut() {
        if (this.scale > 0.2) {
            this.scale -= 0.1;

            this.transform = {
                ...this.transform,
                scale: this.scale
            };
        }
    }

    resetZoom() {
        this.scale = 1;

        this.transform = {
            ...this.transform,
            scale: 1
        };
    }
    onDialogHide() {
        this.imageChangedEvent = null;
        this.croppedImage = null;
        this.croppedImageError = null;
        this.croppedImageSize = 0;
        this.selectedFile = null;

        this.resetZoom();
    }

}
